/**
 * Ant Design theme with the omni-app visual identity (beatly-omni-app src/styles/globals.css):
 * #be43ff for primary actions, focus and selection; #1a1a1a text; #e5e7eb borders; 8–10px radii;
 * light grey table headers and a violet-tinted hover. Only colours, radii and type — no layout sizes.
 */
import type { ThemeConfig } from 'antd';

export const omniTheme: ThemeConfig = {
  token: {
    colorPrimary: '#be43ff',
    colorInfo: '#be43ff',
    colorLink: '#7c3aed',
    colorLinkHover: '#be43ff',
    colorText: '#1a1a1a',
    colorTextSecondary: '#4b5563',
    colorTextTertiary: '#6b7280',
    colorTextQuaternary: '#9ca3af',
    colorBorder: '#e5e7eb',
    colorBorderSecondary: '#eef0f2',
    colorBgLayout: '#f8f9fa',
    colorFillAlter: '#f9fafb',
    colorSuccess: '#12b76a',
    colorWarning: '#f79009',
    colorError: '#f04438',
    borderRadius: 8,
    borderRadiusLG: 12,
    borderRadiusSM: 6,
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    controlOutline: 'rgba(190, 67, 255, 0.15)',
    boxShadowSecondary: '0 10px 25px rgba(16, 24, 40, 0.12)',
  },
  components: {
    Button: { primaryShadow: 'none', defaultShadow: 'none', dangerShadow: 'none', fontWeight: 600 },
    Table: { headerBg: '#f9fafb', headerColor: '#4b5563', headerSplitColor: 'transparent', rowHoverBg: '#fcf7ff', borderColor: '#eef0f2' },
    Tabs: { itemSelectedColor: '#1a1a1a', itemHoverColor: '#be43ff', inkBarColor: '#be43ff' },
    Menu: { itemSelectedBg: 'rgba(190, 67, 255, 0.08)', itemSelectedColor: '#be43ff' },
    Select: { optionSelectedBg: 'rgba(190, 67, 255, 0.08)' },
    Modal: { borderRadiusLG: 16 },
    Card: { borderRadiusLG: 16 },
    Tag: { borderRadiusSM: 999 },
  },
};
